import * as angular from "angular";

export class IssueLogService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/query/log";
    }

    query(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/answers", data);
    }

    statuses(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/statuses", data);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot, data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + data.csqaid, data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + data.csqaid, data);
    }

    assign(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/assign/" + data.csqid, data);
    }

    status(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/status/" + data.csqid, data);
    }

    priority(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/priority/" + data.csqid, data);
    }
}

angular.module("vcServices").service("IssueLogService", IssueLogService);
